module.exports = __webpack_public_path__ + "static/media/blocked.bb007fd8.svg";